"use strict";

exports.__esModule = true;
var styles = {
  drawer: {
    width: 320,
    overflow: "scroll",
    "&::-webkit-scrollbar": {
      width: 5,
      height: 5
    },
    "&::-webkit-scrollbar-thumb": {
      borderRadius: 2,
      backgroundColor: "hsla(0,0%,0%,0.2)",
      minHeight: 5
    }
  }
};
exports["default"] = styles;